import React, { useEffect, useState } from "react";
import { Leaf, Sparkles, Heart, Wheat } from "lucide-react";
import api from "@/lib/api";

const About = () => {
  const [about, setAbout] = useState("");
  useEffect(() => { api.get("/settings").then((r) => setAbout(r.data.about)); }, []);

  return (
    <div>
      <section className="relative">
        <img src="https://static.prod-images.emergentagent.com/jobs/d19db0b9-4d6c-4a45-abc6-252ca7a69ad6/images/e092efd3c64a20b116dd087926cdaa9c61a409e34d3ecad4834e51bebb51487f.jpeg" alt="About" className="h-[42vh] w-full object-cover" />
        <div className="absolute inset-0 bg-chocodark/60 flex items-center justify-center">
          <div className="text-center px-5">
            <p className="text-gold text-xs uppercase tracking-[0.3em] mb-3">Our Story</p>
            <h1 className="font-display text-4xl sm:text-5xl font-bold text-cream">About Nel Bake House</h1>
          </div>
        </div>
      </section>

      <section className="mx-auto max-w-3xl px-5 sm:px-8 py-16 text-center">
        <p className="text-lg text-chocodark/80 leading-relaxed">{about}</p>
      </section>

      <section className="mx-auto max-w-6xl px-5 sm:px-8 pb-20 grid grid-cols-2 lg:grid-cols-4 gap-4 sm:gap-6">
        {[
          { icon: Leaf, t: "No Preservatives" },
          { icon: Sparkles, t: "Pure Ingredients" },
          { icon: Wheat, t: "Freshly Baked" },
          { icon: Heart, t: "Made With Love" },
        ].map((v) => (
          <div key={v.t} className="bg-white rounded-2xl p-6 border border-[#EFEBE1] text-center">
            <div className="h-12 w-12 rounded-full bg-mutedcream flex items-center justify-center text-goldsoft mx-auto"><v.icon size={24} /></div>
            <p className="font-display text-lg font-semibold text-choco mt-4">{v.t}</p>
          </div>
        ))}
      </section>
    </div>
  );
};

export default About;
